import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { BsPlus } from 'react-icons/bs';
import Text from '../components/styled/Text';
import { colors } from '../constants';

const AddRowButton = styled.button`
  border: 1px solid ${colors.grey95};
  height: 36px;
  width: 100%;
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 8px 16px;

  svg {
    margin-right: 8px;
  }
`;

const StickyIconContainer = styled.div`
  padding: 4px;
  width: 80px;
  cursor: pointer;
  position: sticky;
  left: 80px;
  bottom: 48px;
  border: 1px solid ${colors.grey40};
  display: flex;
  align-items: center;
  border-radius: 71px;
  margin: 16px;
`;

const Button = ({ onClick }) => {
  const { t } = useTranslation();
  return (
    <>
      <StickyIconContainer onClick={onClick}>
        <BsPlus fill={colors.grey40} />
        <Text variant="caption" color={colors.grey40}>
          {t('add.row.button')}
        </Text>
      </StickyIconContainer>
      <AddRowButton onClick={onClick}>
        <BsPlus fill={colors.grey40} />
        <Text variant="caption" color={colors.grey40}>
          {t('add.row.button')}
        </Text>
      </AddRowButton>
    </>
  );
};

Button.propTypes = {
  onClick: PropTypes.func,
};

Button.defaultProps = {
  onClick: () => {},
};

export default Button;
